import { Video } from './video';

export class ActiveVideo {
	video : Video; 
}